import styled, { FlattenSimpleInterpolation, css } from 'styled-components';
import Icon from '@minecraft.icon';
import { media } from '@minecraft.themes';

export const StyledHeaderControl = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;

  ${media.lg`
    flex-direction: row;
  `}
`;

export const HeaderControlBlock = styled.div<{ flex?: number }>`
  display: flex;
  flex-direction: column;
  align-items: self-start;
  justify-content: center;
  padding: 0 0 0 1rem;

  ${media.sm`
     padding: 0 0 0 1.875rem;
  `}

  ${({ flex }) => css`
    flex: ${flex};
  `};
`;

export const ProjectBlock = styled(HeaderControlBlock)`
  flex: 1;
  padding-top: 1rem;

  ${media.sm`
     padding-top: 1.4375rem;
  `}

  ${media.lg`
     min-width: 19rem;
     padding-top: unset;
  `}
`;

export const PresentationBlock = styled(HeaderControlBlock)`
  flex: 2;
  padding-top: 0.625rem;
  padding-bottom: 1rem;

  ${media.sm`
     padding-bottom: 1.25rem;
  `}

  ${media.lg`
     padding-top: unset;
     padding-bottom: unset;
  `}
`;

export const BackHomeBlock = styled(HeaderControlBlock)`
  width: 11.25rem;
  padding: 1rem 0 0 1rem;

  a {
    font-size: 0.875rem;
  }

  ${media.sm`
     padding: 1.6875rem 0 0 1.625rem;
  `}

  ${media.lg`
     padding: 0 0 0 1.625rem;
  `}
`;

export const HeaderLogo = styled.div`
  flex-direction: column;
  padding: 0.5rem 1.875rem 0.1875rem 0;
`;

export const CompanyName = styled.div`
  display: flex;
  justify-content: flex-end;
  font-size: 0.75rem;
  font-weight: 600;
  margin-top: 0.3125rem;
`;

export const Logo = styled.div`
  display: flex;
  justify-content: center;
`;

export const LogoPlaceholder = styled.div`
  width: 6.9375rem;
  height: 3.3125rem;
  font-size: 0.875rem;
  font-weight: 600;
  text-align: center;
  display: flex;
  color: ${({ theme }): string => theme.designSystem.textColors.logoPlaceholder};
  background-color: ${({ theme }): string => theme.designSystem.bgColors.logoPlaceholder};

  & > span {
    margin: auto;
    text-transform: uppercase;
  }
`;

export const ControlBlockTitle = styled.div`
  font-size: 0.625rem;
  text-transform: uppercase;
`;

export const ControlBlockName = styled.div<{ $withProjectName?: boolean }>`
  font-size: 1rem;
  font-weight: 600;

  ${({ $withProjectName }) =>
    $withProjectName
      ? css`
          ${media.sm`
            font-size: 1.25rem;
          `}

          ${media.md`
            font-size: 1.5rem;
          `}
        `
      : css`
          ${media.sm`
            font-size: 1.5rem;
          `}
        `}
`;

export const ChevronLeft = styled(Icon)`
  width: 1.0625rem;
  height: 1.0625rem;
  margin: 0 0.5rem 0.2rem 0;
`;

export const Header = styled.div`
  background-color: ${({ theme }): string => theme.designSystem.bgColors.presentationHeaderSm};
  display: flex;
  flex-direction: row;
  min-height: 5.5rem;
  color: ${({ theme }): string => theme.designSystem.textColors.presentationHeaderSm};

  ${({ theme }): FlattenSimpleInterpolation => css`
    ${BackHomeBlock} {
      a {
        color: ${theme.designSystem.textColors.presentationHeaderSm};
      }
    }

    ${ControlBlockTitle} {
      color: ${theme.designSystem.textColors.presentationHeaderLabel};
    }
  `}
`;
